export const SET_BIZ_USER_INFO = 'SET_USER_INFO'
export const SET_MIS_USER_INFO = 'SET_MIS_USER_INFO'
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
export const SET_FROM_PAGE = 'SET_FROM_PAGE'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_PAGE_ACCOUNT_TYPE = 'SET_PAGE_ACCOUNT_TYPE'
export const SET_CUSTOMS = 'SET_CUSTOMS'
export const SET_TRIP_NOTIFY = 'SET_TRIP_NOTIFY'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js